module.exports = __webpack_public_path__ + "1da84c56006f0323787b23f29d916fc9.png";